// extracted by mini-css-extract-plugin
module.exports = {"inp":"textfield_inp__3GORF","label":"textfield_label__E-C7y","focus-bg":"textfield_focus-bg__2P7mi","bordered":"textfield_bordered__1IuIX"};